import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet(() => ({
  root: { alignItems: 'center', gap: rh(24), width: '100%' },
  qr: { width: rw(180), height: rw(180), overflow: 'hidden', borderRadius: rw(20) },
  skeleton: { width: '100%', height: '100%' },
  caption: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: rw(4) },
}))
